module.exports = pinyinPro;